import { render, staticRenderFns } from "./GradingScale.vue?vue&type=template&id=a1d53fe6&"
import script from "./GradingScale.vue?vue&type=script&lang=js&"
export * from "./GradingScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports